import React from 'react';
import { connect } from 'react-redux';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import validator from 'validator';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import {
  connectGoogleEmail,
  closeConnectGoogleEmailModal,
} from 'actions/onlineStore';
import styles from './ConnectEmailModal.css';
import EmailField from './EmailField';

function isGmail(email) {
  return email.indexOf('@gmail.') !== -1;
}

const validate = values => {
  const errors = {};
  if (!values.email) {
    errors.email = 'Google ID should not be empty';
  } else if (!validator.isEmail(values.email) || !isGmail(values.email)) {
    errors.email = 'Please enter a valid Google Email Address';
  }
  return errors;
};

class ConnectEmailModal extends React.Component {
  render() {
    const { show, invalid } = this.props;

    return (
      <ConfirmModal
        dialogClassName={styles.modal}
        showModal={show}
        title="Register Google Email"
        description={this._renderContent()}
        confirmTitle="Register"
        onConfirm={this._handleConfirm}
        onHide={this._handleHide}
        confirmDisabled={invalid}
      />
    );
  }

  _renderContent = () => {
    return (
      <div>
        <p>
          Register outlet Google email to see your product performance report in{' '}
          <a
            href="https://www.google.com/retail/solutions/merchant-center/"
            target="_blank"
            className={styles['text-underline']}
          >
            Google Merchant Center
          </a>
          .
        </p>

        <form onSubmit={this._handleSubmit}>
          <div className="row">
            <div className="col-md-5">Google Email ID</div>
            <div className="col-md-7">
              <div className="form-group">
                <Field
                  component={EmailField}
                  name="email"
                  type="text"
                  placeholder="e.g. name@gmail.com"
                  autoCorrect="off"
                  maxLength="40"
                  autoCapitalize="off"
                  spellCheck="false"
                  className="form-control"
                />
              </div>
            </div>
          </div>
        </form>

        <p className={styles['small-text']}>
          Don’t have Google email yet? Register{' '}
          <a
            href="https://www.google.com/intl/en-GB/gmail/about/#"
            target="_blank"
            className={styles['text-underline']}
          >
            here
          </a>
        </p>
      </div>
    );
  };

  _handleSubmit = e => {
    e.preventDefault();
  };

  _handleConfirm = () => {
    const { shop, email } = this.props;
    this.props.dispatch(connectGoogleEmail(shop, email));
  };

  _handleHide = () => {
    this.props.dispatch(closeConnectGoogleEmailModal());
  };
}

const mapFormValidation = {
  form: 'connectEmailForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

function mapStateToProps(state) {
  const { showConnectEmailModal, connectEmailShop } = state.onlineStore.google;

  return {
    email: formValueSelector(mapFormValidation.form)(state, 'email'),
    shop: connectEmailShop,
    show: showConnectEmailModal,
  };
}

export default connect(mapStateToProps)(
  reduxForm(mapFormValidation)(ConnectEmailModal)
);
